
const SET_NEW_PASSWORD_LOCALE_TEMPLATES = {
    "en": {
        "set.new.password.title.mobile": "Forgot your password?",
        "set.new.password.title": "Forgot your <br/> password?",
        "set.new.password": "New password",
        "set.new.password.minimum.password.characters": "Please note: minimum 12 characters",
        "set.new.password.repeat": "Repeat password",
        "set.new.password.button.label": "Reset",
        "set.new.password.resend.link": "Link expired? Resend here",

        "set.new.password.mismatch": "Passwords do not match",
        "set.new.password.both.fields": "Both fields are required",
        "set.new.password.success": "Updated successfully!",
    },
    "nl": {
        "set.new.password.title.mobile": "Wachtwoord vergeten?",
        "set.new.password.title": "Wachtwoord <br /> vergeten?",
        "set.new.password": "Nieuw wachtwoord",
        "set.new.password.minimum.password.characters": "Let op: minimaal 12 tekens",
        "set.new.password.repeat": "Herhaal wachtwoord",
        "set.new.password.button.label": "Resetten",
        "set.new.password.resend.link": "Link verlopen? Stuur hier opnieuw",
        "set.new.password.mismatch": "De wachtwoorden komen niet overeen",
        "set.new.password.both.fields": "Beide velden zijn verplicht",
        "set.new.password.success": "Succesvol aangepast!",
    }
}

export default SET_NEW_PASSWORD_LOCALE_TEMPLATES;